import React from 'react';

import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { Helmet } from 'react-helmet';
import Alert from '../../container/Alert';
import Footer from '../Footer';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'user.registration.label.name',
    description: 'Page Header Title',
    defaultMessage: 'User Registration'
  },
  headerSubTitle: {
    id: 'empty.label.name',
    description: 'Page Header Subtitle',
    defaultMessage: ' '
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

const Register = ({ register, locale, intl, status }) => (
  <div className="preview page">
    <Helmet>
      <title>{intl.formatMessage(messages.htmlHeader)} - SHIFT</title>
    </Helmet>
    <Header
      title={intl.formatMessage(messages.headerTitle)}
      subtitle={intl.formatMessage(messages.headerSubTitle)}
      icon="preview"
      locale={locale}
    />

    <Alert
      title="Signup Error"
      body="Invalid Username"
      message={print(status)}
    />

    <div className="main">
      <div
        className="panel"
        style={{
          width: '60%',
          padding: '40px',
          boxSizing: 'content-box',
          marginTop: '15px',
          display: 'block',
          alignContent: 'center',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
      >
        <LocalForm
          onSubmit={({ firstname, lastname, email, telephone }) =>
            register(firstname, lastname, email, telephone)
          }
          className="form"
        >
          <fieldset>
            <label style={{ textTransform: 'capitalize' }}>
              <FormattedMessage
                id="user.firstname.title"
                defaultMessage="First Name: "
              />
            </label>
            <Control.text model=".firstname" autoFocus required length={8} />
          </fieldset>

          <fieldset>
            <label style={{ textTransform: 'capitalize' }}>
              <FormattedMessage
                id="user.lastname.title"
                defaultMessage="Last Name: "
              />
            </label>
            <Control.text model=".lastname" autoFocus required length={8} />
          </fieldset>

          <fieldset>
            <label style={{ textTransform: 'capitalize' }}>
              <FormattedMessage
                id="assessment.request.translation.Email.name"
                defaultMessage="Email"
              />
            </label>

            <Control.text
              validators={{
                endwith: val => !val || `${val}`.endsWith('nextpathway.com')
              }}
              model=".email"
              type="email"
              required
              autoFocus
            />
            <Errors
              className="error"
              model=".email"
              messages={{
                endwith: 'Invalid email address.'
              }}
            />
          </fieldset>

          <fieldset>
            <label style={{ textTransform: 'capitalize' }}>
              <FormattedMessage
                id="telephone.label.name"
                defaultMessage="Telephone"
              />
            </label>

            <Control.text
              validators={{
                // validPhoneNumber: val => {
                //   return !val || /^\d+$/.test(val);
                // }

                validPhoneNumber: val => !val || /^\d+$/.test(val),


                length: val => !val || `${val}`.length === 10

              }}
              model=".telephone"
              autoFocus
              required
            />

            <Errors
              className="error"
              model=".telephone"
              messages={{
                validPhoneNumber: 'Invalid phone number. ',
                length: 'Phone Number length should be 10.'
              }}
            />
          </fieldset>

          <div className="button-container" style={{ textAlign: 'center' }}>
            <button className="button" type="submit">
              <FormattedMessage
                id="signup.button.name"
                defaultMessage="Sign Up"
              />
            </button>
          </div>
        </LocalForm>
      </div>
    </div>
    <Footer />
  </div>
);

Register.propTypes = {
  register: PropTypes.func.isRequired,
  locale: PropTypes.string,
  intl: PropTypes.object,
  status: PropTypes.object
};

export default injectIntl(Register);



// WEBPACK FOOTER //
// ./src/components/views/Register/index.js